import { getFutureHazardLevelIndex } from "helpers/future-hazard-legend";

/**
 * 根据风险评分返回相应的风险等级描述
 *
 * @param score - 风险评分值 (0-10)
 * @returns 对应的风险等级描述字符串
 *
 * 风险等级划分规则：
 * - Extreme (8 - 10)
 * - Significant (6 - 8)
 * - Moderate (4 - 6)
 * - Minor (2 - 4)
 * - Negligible (0 - 2)
 *
 * @example
 * getRiskLevel(9.5) // 返回 "Extreme"
 * getRiskLevel(7) // 返回 "Significant"
 * getRiskLevel(1.5) // 返回 "Negligible"
 */
export function getRiskLevel(t: any, value: any): string {
  // 将输入转换为数字
  const score = parseFloat(value);

  // 处理 NaN 情况
  if (isNaN(score)) {
    return ""; // 或者返回 "Unknown" 或其他适当的默认值
  }

  if (score >= 8) {
    return t("report.Extreme");
  } else if (score >= 6) {
    return t("report.Significant");
  } else if (score >= 4) {
    return t("report.Moderate");
  } else if (score >= 2) {
    return t("report.Minor");
  } else {
    return t("report.Negligible");
  }
}

export function getFutureHazardRiskLevel(t: any, value: any): string {
  const score = parseFloat(value);

  if (isNaN(score)) {
    return "";
  }

  const futureHazardLabels = [
    t("legend.futureHazardData", { returnObjects: true })?.[0]?.[1] ||
      "Very Low",
    t("legend.futureHazardData", { returnObjects: true })?.[0]?.[2] || "Low",
    t("legend.futureHazardData", { returnObjects: true })?.[0]?.[3] ||
      "Moderate",
    t("legend.futureHazardData", { returnObjects: true })?.[0]?.[4] || "High",
    t("legend.futureHazardData", { returnObjects: true })?.[0]?.[5] ||
      "Very High",
    t("legend.futureHazardData", { returnObjects: true })?.[0]?.[6] || "Extreme"
  ];

  const levelIndex = getFutureHazardLevelIndex(score);

  return levelIndex ? futureHazardLabels[levelIndex - 1] || "" : "";
}

export const Color = (value: any, category?: string) => {
  const isFutureHazard = category === "futureHazard";

  if (isNaN(value)) {
    return "#ffffff"; // 非数字值默认白色背景
  }
  const num = parseFloat(value);

  if (isFutureHazard) {
    const levelIndex = getFutureHazardLevelIndex(num);

    switch (levelIndex) {
      case 1:
        return "#275317";
      case 2:
        return "#4EA72E";
      case 3:
      case 4:
      case 5:
        return "#9C0006";
      default:
        return "#FFFFFF";
    }
  } else {
    // 通用 5 级颜色方案（分数范围 0-10）
    if (num < 2) {
      return "#275317"; // rgb(39, 83, 23)
    } else if (num >= 2 && num < 4) {
      return "#4EA72E"; // rgb(78, 167, 46)
    } else if (num >= 4 && num < 6) {
      return "#9C0006"; // rgb(156, 0, 6)
    } else if (num >= 6 && num < 8) {
      return "#9C0006"; // rgb(156, 0, 6)
    } else {
      return "#FFFFFF"; // rgb(255, 255, 255)
    }
  }
};

export const BgColor = (value: any, category?: string) => {
  const isFutureHazard = category === "futureHazard";

  if (isNaN(value)) {
    return "#BFBFBF"; // 非数字值默认白色背景
  }
  const num = parseFloat(value);

  if (isFutureHazard) {
    const levelIndex = getFutureHazardLevelIndex(num);

    switch (levelIndex) {
      case 1:
        return "#b5e6a2";
      case 2:
        return "#daf2d0";
      case 3:
        return "#ffffcc";
      case 4:
        return "#F2AA84";
      case 5:
        return "#ffc7ce";
      default:
        return "#cc0000";
    }
  } else {
    // 通用 5 级颜色方案（分数范围 0-10）
    if (num < 2) {
      return "#B5E6A2"; // rgb(181, 230, 162)
    } else if (num >= 2 && num < 4) {
      return "#DAF2D0"; // rgb(218, 242, 208)
    } else if (num >= 4 && num < 6) {
      return "#FFFFCC"; // rgb(255, 255, 204)
    } else if (num >= 6 && num < 8) {
      return "#FFC7CE"; // rgb(255, 199, 206)
    } else {
      return "#CC0000"; // rgb(204, 0, 0)
    }
  }
};
